<script setup lang="ts">
	const props = defineProps({
		show: Boolean,
		msg: String
	});	
</script>
<template>
	<Transition name="errorfade">
		<div v-if="show" class="errors">
			<span class="perr">{{msg}}</span>
		</div>
	</Transition>
</template>
